import { Modal, Typography } from "antd";
import AppButton from "components/libs/button";
import React, { useEffect, useRef, useState } from "react";
import Phone from "../../assets/images/app/phone_verif.svg";

const { Text } = Typography;

interface OtpModalProps {
    visible: boolean;
    phone: string;
    onCancel: () => void;
    onVerify: (otp: string) => void;
    onResend: () => void;
    isLoading: boolean;
}

const PhoneOTPModal: React.FC<OtpModalProps> = ({ visible, phone, onCancel, onVerify, onResend, isLoading }) => {

    const [otp, setOtp] = useState<string[]>(Array(6).fill(''));
    const inputsRef = useRef<(HTMLInputElement | null)[]>([]);
    const [canResendCode, setCanResendCode] = useState<boolean>(false);
    const [timer, setTimer] = useState(120);

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1050);
    };
    window.addEventListener('resize', handleResize);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const newOtp = [...otp];
        newOtp[index] = e.target.value;
        setOtp(newOtp);

        // Move to the next input field if needed
        if (e.target.value && index < 5) {
            const nextInput = document.getElementById(`otp-input-${index + 1}`);
            nextInput?.focus();
        }
    };

    const handlePasteOrInput = (e: React.FormEvent<HTMLInputElement> | React.ClipboardEvent<HTMLInputElement>) => {
        let pastedData = "";

        if ("clipboardData" in e) {
            // Desktop paste
            e.preventDefault();
            pastedData = e.clipboardData.getData("text").trim();
        } else {
            // Mobile input (Safari/iOS often fires this instead of paste)
            pastedData = (e.currentTarget as HTMLInputElement).value.trim();
        }

        if (!/^\d+$/.test(pastedData)) return;

        const pastedArray = pastedData.split("").slice(0, otp.length);
        const newOtp = [...otp];

        pastedArray.forEach((num, index) => {
            newOtp[index] = num;
        });

        setOtp(newOtp);
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputsRef.current[index - 1]?.focus(); // move back
        }
    };

    const handleSubmit = () => {

        const otpValue = otp.join('');

        if (otpValue.length !== 6) {
            alert("Entre le code OTP reçu sur le numéro !");
            return;
        }

        // Call API or handle OTP verification
        onVerify(otpValue);
    };

    const handleResend = () => {
        setCanResendCode(false);
        setTimer(120);
        onResend();
    };

    useEffect(() => {
        let interval: ReturnType<typeof setInterval>;

        if (!canResendCode && timer > 0) {
            interval = setInterval(() => {
                setTimer(prev => prev - 1);
            }, 1000);
        }

        if (timer === 0) {
            setCanResendCode(true);
        }

        return () => clearInterval(interval);
    }, [canResendCode, timer]);

    return (
        <Modal
            title={null}
            visible={visible}
            onCancel={onCancel}
            footer={null}
            centered
        >
            <div style={{ textAlign: "center" }}>
                <img src={Phone} height={70} style={{ marginBottom: "10px" }}></img>
                <Text strong style={{ display: "block", marginBottom: 8 }}>
                    Vérification du numéro de téléphone
                </Text>
                <Text>
                    Nous avons envoyé par sms un code au <b>{phone}</b>
                </Text>

                {/* OTP input (AntD v5) */}
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", margin: "40px auto" }}>
                    {otp.map((value, index) => (
                        <input
                            key={index}
                            id={`otp-input-${index}`}
                            ref={(el) => (inputsRef.current[index] = el)}
                            type="text"
                            inputMode="numeric"
                            value={value}
                            onChange={(e) => handleChange(e, index)}
                            maxLength={otp.length}
                            onPaste={handlePasteOrInput}
                            onInput={handlePasteOrInput}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            style={{ height: isMobile ? "30px" : "50px", width: isMobile ? "30px" : "50px", textAlign: 'center', marginRight: '5px', marginLeft: "5px", border: "1px solid #ccc", borderRadius: isMobile ? "5px" : "8px" }}
                        />
                    ))}
                </div>

                <div style={{ marginBottom: 15 }}>
                    {canResendCode ? <Text type="secondary">
                        Code pas reçu ?{" "}
                        <a onClick={handleResend} style={{ cursor: "pointer" }}>
                            Renvoyer le code
                        </a>
                    </Text> : <Text type="secondary">
                        <a style={{ cursor: "pointer" }}>
                            Renvoyer le code dans {timer}s
                        </a>
                    </Text>}
                </div>

                <AppButton
                    onClick={() => handleSubmit()}
                    disabled={otp.length < 6}
                    loading={isLoading}
                >
                    Vérifier et Continuer
                </AppButton>
            </div>
        </Modal>
    );
};

export default PhoneOTPModal;
